// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"2efc1ce481341f06e173","655":"07791f4edc20f248d2bb"}[chunkId] + ".js";
};